import { createSlice } from '@reduxjs/toolkit';
import { IAccountSettingsState } from './types';
import { updateAdminProfile, checkUsernameUniqueness } from './actions';

const initialState: IAccountSettingsState = {
  adminDetailsUpdating: false,
  adminDetailsUpdateMessage: null,
  adminDetailsUpdateError: null,
  checkingUsernameUniqueness: false,
  isUsernameUnique: null, // null, true, or false
  usernameUniqueError: null,
};

const accountSettingsSlice = createSlice({
  name: 'accountSettings',
  initialState,
  reducers: {
    resetUsernameUniqueness: (state) => {
      state.checkingUsernameUniqueness = false;
      state.isUsernameUnique = null;
      state.usernameUniqueError = null;
    },
    clearMessage(state) {
      state.adminDetailsUpdateMessage = null;
    },
    clearError(state){
      state.adminDetailsUpdateError= null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAdminProfile.pending, (state) => {
        state.adminDetailsUpdating = true;
        state.adminDetailsUpdateError = null;
      })
      .addCase(updateAdminProfile.fulfilled, (state, action) => {        
        state.adminDetailsUpdating = false;
        state.adminDetailsUpdateMessage = action.payload.message;
      })
      .addCase(updateAdminProfile.rejected, (state, action) => {
        state.adminDetailsUpdating = false;
        state.adminDetailsUpdateError = (action.payload as any).message  || 'Failed to update Profile';
      })

      .addCase(checkUsernameUniqueness.pending, (state) => {
        state.checkingUsernameUniqueness = true;
        state.usernameUniqueError = null;
        state.isUsernameUnique = null; // Reset when a new check starts
      })
      .addCase(checkUsernameUniqueness.fulfilled, (state, { payload }) => {
        state.checkingUsernameUniqueness = false;        
        state.isUsernameUnique = payload; // Payload is boolean (true/false)
      })
      .addCase(checkUsernameUniqueness.rejected, (state, { payload }) => {
        state.checkingUsernameUniqueness = false;
        state.isUsernameUnique = false; // Assume not unique or an error occurred
        state.usernameUniqueError = payload as any;
      });
  },
});

export const { resetUsernameUniqueness, clearMessage, clearError } = accountSettingsSlice.actions;

export default accountSettingsSlice.reducer;
